<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="菜单名称">
            <el-input v-model="queryParams.menuName" placeholder="请输入菜单名称进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="addMenu">新增一级菜单</el-button>
              <!-- <el-button
                :disabled="!multipleSelection.length"
                icon="el-icon-delete"
                type="danger"
                @click="batchDelete"
              >批量删除</el-button>-->
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="menuId" :tree-props="{ children: 'children' }"
        highlight-current-row height="800"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green', cursor: 'pointer' } : { color: 'red', cursor: 'pointer' }">{{
          scope.row.status === '0' ? '正常' : '停用' }}</span>

            <span v-else-if="tab.code === 'icon'">
              <i :class="scope.row.icon"></i>
            </span>
            <!-- 其他列的常规隐藏 -->
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="addData(scope.row)" class="update-btn">新增</el-button>
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <!-- <div>
        <Pagination
          :total="pageParams.total"
          :page="pageParams.pageNum"
          :limit="pageParams.pageSize"
          @pagination="onChangePages"
        />
      </div>-->
    </div>
    <!-- 添加 修改菜单 -->
    <el-dialog :title="dialogTitle" :visible.sync="formVisible" width="800px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="上级菜单" prop="menuType">
          <treeselect disabled size="mini" v-model="form.parentId" :options="menuOptions" :normalizer="normalizer"
            :show-count="true" placeholder="请选择" />
        </el-form-item>

        <el-form-item label="菜单类型" prop="menuType">
          <el-select v-model="form.menuType" placeholder="请选择菜单类型">
            <el-option :disabled="menuDisabledM" label="目录" value="M"></el-option>
            <el-option :disabled="menuDisabledC" label="菜单" value="C"></el-option>
            <el-option :disabled="menuDisabledF" label="按钮" value="F"></el-option>
          </el-select>
        </el-form-item>
        <!-- 目录 -->
        <div v-if="form.menuType === 'M'">
          <el-form-item label="菜单图标">
            <el-popover placement="bottom-start" width="645" trigger="click" @show="$refs['iconSelect'].reset()">
              <IconSelect ref="iconSelect" @selected="selected" />
              <el-input slot="reference" v-model="form.icon" placeholder="点击选择图标" readonly>
                <i style="margin-left:5px;font-size:14px" :class="form.icon" slot="prefix"></i>
                <!-- <svg-icon
                  v-if="form.icon"
                  slot="prefix"
                  :icon-class="form.icon"
                  class="el-input__icon"
                  style="height: 32px;width: 16px;"
                />
                <i v-else slot="prefix" class="el-icon-search el-input__icon" />-->
              </el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="菜单名称" prop="menuName">
            <el-input v-model="form.menuName" autocomplete="off" placeholder="请输入菜单名称"></el-input>
          </el-form-item>
          <el-form-item label="显示排序" prop="orderNum">
            <el-input type="number" min="0" v-model="form.orderNum" autocomplete="off" placeholder="请输入显示排序"></el-input>
          </el-form-item>
          <el-form-item label="路由地址" prop="path">
            <el-input v-model="form.path" autocomplete="off" placeholder="请输入路由地址"></el-input>
          </el-form-item>
          <el-form-item label="组件路径" prop="component">
            <el-input v-model="form.component" autocomplete="off" placeholder="请输入组件路径"></el-input>
          </el-form-item>
          <el-form-item label="显示状态" prop="visible">
            <el-select v-model="form.visible" placeholder="请选择显示状态">
              <el-option label="显示" value="0"></el-option>
              <el-option label="隐藏" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择菜单状态">
              <el-option label="正常" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div v-if="form.menuType === 'C'">
          <el-form-item label="菜单图标">
            <el-popover placement="bottom-start" width="645" trigger="click" @show="$refs['iconSelect'].reset()">
              <IconSelect ref="iconSelect" @selected="selected" />
              <el-input slot="reference" v-model="form.icon" placeholder="点击选择图标" readonly>
                <i style="margin-left:5px;font-size:14px" :class="form.icon" slot="prefix"></i>
                <!-- <i class="el-icon-edit el-input__icon" slot="prefix"></i> -->
                <!-- <svg-icon
                  v-if="form.icon"
                  slot="prefix"
                  :icon-class="form.icon"
                  class="el-input__icon"
                  style="height: 32px;width: 16px;"
                />
                <i v-else slot="prefix" class="el-icon-search el-input__icon" />-->
              </el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="菜单名称" prop="menuName">
            <el-input v-model="form.menuName" autocomplete="off" placeholder="请输入菜单名称"></el-input>
          </el-form-item>
          <el-form-item label="显示排序" prop="orderNum">
            <el-input type="number" min="0" v-model="form.orderNum" autocomplete="off" placeholder="请输入显示排序"></el-input>
          </el-form-item>
          <el-form-item label="路由地址" prop="path">
            <el-input v-model="form.path" autocomplete="off" placeholder="请输入路由地址"></el-input>
          </el-form-item>
          <el-form-item label="组件路径" prop="component">
            <el-input v-model="form.component" autocomplete="off" placeholder="请输入组件路径"></el-input>
          </el-form-item>
          <el-form-item label="权限标识" prop="perms">
            <el-input v-model="form.perms" autocomplete="off" placeholder="请输入权限标识"></el-input>
          </el-form-item>
          <el-form-item label="是否缓存" prop="isCache">
            <el-select v-model="form.isCache" placeholder="请选择是否缓存">
              <el-option label="缓存" value="0"></el-option>
              <el-option label="不缓存" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="显示状态" prop="visible">
            <el-select v-model="form.visible" placeholder="请选择显示状态">
              <el-option label="显示" value="0"></el-option>
              <el-option label="隐藏" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择菜单状态">
              <el-option label="正常" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div v-if="form.menuType === 'F'">
          <el-form-item label="按钮名称" prop="menuName">
            <el-input v-model="form.menuName" autocomplete="off" placeholder="请输入按钮名称"></el-input>
          </el-form-item>
          <el-form-item label="显示排序" prop="orderNum">
            <el-input type="number" min="0" v-model="form.orderNum" autocomplete="off" placeholder="请输入显示排序"></el-input>
          </el-form-item>
          <el-form-item label="权限标识" prop="perms">
            <el-input v-model="form.perms" autocomplete="off" placeholder="请输入权限标识"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IconSelect from "@/components/IconSelect";

import {getMenuTree, menuAdd, menuById,updeteMenu,deleteMenu} from "@/api/admin-service/menu.js";
export default {
  components: {
    // Pagination
    Treeselect,
    IconSelect
  },
  data() {
    return {
      tableLoading: false,
      form: {
        menuName: "", //菜单名称
        parentId: null, //父级ID
        ancestors: "", //祖级列表
        orderNum: "",
        isCache: "",
        menuType: "",
        visible: "",
        status: "", //菜单状态
        perms: "", //权限标识
        icon: "", //图标
        component: "", //组件路径
        path: "" //路由地址
      },
      menuOptions: [],
      rules: {
        menuName: [
          { required: true, message: "请填写菜单名称", trigger: "blur" }
        ],
        orderNum: [
          {
            required: true,
            message: "请填写显示排序",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              // 校验是否为正整数且大于 0
              if (!value) {
                callback(new Error("请填写显示排序"));
              } else if (!/^[1-9]\d*$/.test(value)) {
                callback(new Error("显示排序必须是大于 0 的正整数"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        isCache: [
          { required: true, message: "请选择是否缓存", trigger: "change" }
        ],
        menuType: [
          { required: true, message: "请选择菜单类型", trigger: "change" }
        ],
        visible: [
          { required: true, message: "请选择菜单显示状态", trigger: "change" }
        ],
        // component: [
        //   { required: true, message: "请输入组件路径", trigger: "change" }
        // ],
        path: [
          { required: true, message: "请选择路由地址", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择菜单状态", trigger: "change" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      formVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "菜单名称", code: "menuName", width: "" },
        { name: "显示排序", code: "orderNum", width: "" },
        { name: "是否缓存", code: "isCache", width: "" },
        { name: "组件路径", code: "path", width: "" },
        { name: "菜单类型", code: "menuType", width: "" },
        { name: "菜单图标", code: "icon", width: "" },
        { name: "显示状态", code: "visible", width: "" },
        { name: "菜单状态", code: "status", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        menuName: ""
      },
      menuDisabledM: false,
      menuDisabledC: false,
      menuDisabledF: false
    };
  },
  mounted() {
    this.onGetDataList();
  },
  methods: {
    // 选择图标
    selected(name) {
      this.form.icon = name;
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.label,
        children: node.children
      };
    },
    addMenu() {
      //  点击新增按钮  只能新增最顶级菜单
      //  1.上级菜单默认为 '主类目'
      //  2.菜单类型默认为目录
      //  3.parentId 为 0
      //  4.清空图标
      this.menuDisabledC = true;
      this.menuDisabledF = true;
      this.dialogTitle = "新增";
      this.formVisible = true;
      this.menuOptions = [
        {
          id: "0",
          label: "主类目",
          parentId: 0,
          children: []
        }
      ];
      this.form.menuType = "M";
      this.form.parentId = 0;
      this.form.menuName = "";
      this.form.isCache = "";
      this.form.orderNum = "";
      this.form.visible = "";
      this.form.status = "";
      this.form.path = "";
      this.form.icon = "";
    },
    /** 查询类型下拉树结构 */
    getTreeselect() {
      getMenuTree({}).then(r => {
        // 定义一个递归函数来处理树形结构
        const processMenuItem = item => {
          // 创建菜单项，处理自身的 label 和 id
          const menu = {
            label: item.menuName,
            id: item.menuId,
            parentId: item.parentId,
            ...item
          };
          // 如果当前菜单项有 children，则递归处理
          if (item.children && item.children.length > 0) {
            menu.children = item.children.map(child => processMenuItem(child)); // 递归调用
          }
          return menu;
        };
        // 处理返回的树形数据
        const menuItem = {
          id: "0",
          label: "主类目",
          parentId: 0,
          children: r.data.map(item => processMenuItem(item)) // 递归处理每个顶层菜单项
        };
        // 将处理后的菜单项推入菜单选项列表
        this.menuOptions.push(menuItem);
      });
    },
    addData(row) {
      this.formVisible = true;

      if (row.menuType === "目录") {
        this.menuDisabledM = false;
        this.menuDisabledC = false;
        this.menuDisabledF = true;
      } else if (row.menuType === "菜单") {
        this.menuDisabledM = true;
        this.menuDisabledC = true;
        this.menuDisabledF = false;
      }
      this.getTreeselect();
      this.dialogTitle = "新增";
      this.form.parentId = row.menuId; //新增 需要上级id 默认是第一级
      this.form.menuName = "";
      this.form.isCache = "";
      this.form.menuType = "";
      this.form.orderNum = "";
      this.form.visible = "";
      this.form.status = "";
      this.form.path = "";
      this.form.icon = "";
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.menuId; // 清除 menuId
            menuAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.formVisible = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteMenu({
              ...this.form,
              menuId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.formVisible = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(
        `提示，确定要删除 <span style="color: red; font-weight: bold;">${row.menuName}</span> 及其下属的所有菜单或按钮吗？`,
        {
          title: "提示",
          showCancelButton: true,
          confirmButtonText: "确 定",
          cancelButtonText: "取 消",
          type: "warning",
          // 为按钮添加图标并设置为 mini 尺寸
          confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
          cancelButtonClass: "el-icon-close el-button--mini", // 取消按钮的图标和尺寸
          dangerouslyUseHTMLString: true // 允许渲染 HTML 字符串
        }
      )
        .then(() => {
          deleteMenu({ ids: [row.menuId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.getTreeselect();
      //点击修改按钮  要分情况
      this.menuDisabledM = true;
      this.menuDisabledC = true;
      this.menuDisabledF = true;
      if (row.parentId === "0") {
        // 如果点击的是最顶级 也就是parentId为0的时候
        this.menuOptions = [
          {
            id: "0",
            label: "主类目",
            parentId: 0,
            children: []
          }
        ];
      }
      this.dialogTitle = "修改";
      this.formVisible = true;
      this.updateId = row.menuId;
      // 回显
      menuById({ id: row.menuId }).then(res => {
        Object.assign(this.form, res?.data);
        // const {
        //   menuName,
        //   isCache,
        //   menuType,
        //   orderNum,
        //   visible,
        //   status,
        //   path,
        //   icon,
        //   parentId,
        //   component
        // } = res.data;
        // this.form.menuName = menuName;
        // this.form.isCache = String(isCache);
        // this.form.menuType = menuType;
        // this.form.orderNum = orderNum;
        // this.form.visible = visible;
        // this.form.status = status;
        // this.form.path = path;
        // this.form.icon = icon;
        // this.form.parentId = parentId;
        // this.form.component = component;
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getMenuTree({
        menuName: this.queryParams.menuName
      })
        .then(res => {
          // 菜单类型映射
          const menuTypeMapping = {
            M: "目录",
            C: "菜单",
            F: "按钮"
          };
          // 递归处理节点的函数
          const processNode = node => {
            return {
              ...node,
              isCache:
                node.isCache === null
                  ? ""
                  : node.isCache === 0
                    ? "缓存"
                    : "不缓存",
              visible: node.visible === "0" ? "显示" : "隐藏",
              menuType: menuTypeMapping[node.menuType],
              // 如果有子节点，递归处理
              children: node.children
                ? node.children.map(child => processNode(child))
                : []
            };
          };
          // 遍历根节点数据并递归处理
          this.tableData = res.data.map(item => processNode(item));
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handleDialogClose() {
      this.form.menuId = "";
      this.form.parentId = "";
      this.form.menuType = null;
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.menuName = "";
      this.onSearch();
    }
    // 分页方法
    // onChangePages(pageInfo) {
    //   this.pageParams.pageNum = pageInfo.page;
    //   this.pageParams.pageSize = pageInfo.limit;
    //   this.onGetDataList();
    // }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
